import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Collapsible } from '../../Internals';

const Panel = ({
  children,
  expanded,
  id,
  panelClassName,
  panelContentClassName,
  panelRef,
  renderOnExpand,
  removeAriaLabelledBy,
}) => {
  const classes = cn(
    'c-accordion__panel',
    {
      'is-open': expanded,
    },
    panelClassName
  );
  const role = expanded ? 'region' : '';

  if (renderOnExpand && !expanded) {
    return null;
  }

  const ariaLabelledByProp = removeAriaLabelledBy
    ? {}
    : { 'aria-labelledby': `${id}-trigger` };

  return (
    <Collapsible
      {...ariaLabelledByProp}
      className={classes}
      collapsibleRef={panelRef}
      contentClassName={panelContentClassName}
      expanded={expanded}
      id={`${id}-panel`}
      role={role}
      tabIndex={expanded ? '0' : '-1'}
    >
      {children}
    </Collapsible>
  );
};

export default Panel;

Panel.propTypes = {
  children: PropTypes.node,
  expanded: PropTypes.bool,
  id: PropTypes.string.isRequired,
  panelClassName: PropTypes.string,
  panelContentClassName: PropTypes.string,
  panelRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
    .isRequired,
  removeAriaLabelledBy: PropTypes.bool,
};

Panel.defaultProps = {
  children: null,
  expanded: false,
  panelClassName: '',
  panelContentClassName: '',
  removeAriaLabelledBy: false,
};
